export interface SamlExchangeRequest {
	code: string;
}

export interface CredentialsLoginRequest {
	email: string;
	password: string;
}

export interface LoginResponse {
	accessToken: string;
	refreshToken: string;
	user: User;
}

export interface AccessedModule {
	moduleId: string;
	moduleName: string;
	code?: string;
	permissions: string;
}

export interface User {
	id: string;
	email: string;
	name: string;
	accessedModules?: AccessedModule[];
}

export const AuthProvider = {
	SAML: "saml",
	CREDENTIALS: "credentials",
} as const;

export type AuthProvider = (typeof AuthProvider)[keyof typeof AuthProvider];

export interface AuthState {
	accessToken: string | null;
	refreshToken: string | null;
	user: User | null;
	isAuthenticated: boolean;
	authProvider: AuthProvider | null;
	/**
	 * Local-dev only: simulates READ / READ_WRITE / APPROVE for RBAC preview.
	 * Ignored when `isReadOnlyPreviewAllowed()` is false.
	 */
	mockAccessPreview: "READ" | "READ_WRITE" | "APPROVE";
}
